import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-button-toggle-vehicle',
  template: `<div class="skeleton-container">
    <div class="skeleton-circle"></div>
    <div class="skeleton-text"></div>
  </div>`,
  styleUrls: ['./skeleton-button-toggle-vehicle.component.scss'],
})
export class SkeletonButtonToggleVehicleComponent {}
